import { EDGE_TYPE, EHChangeCrossCursor, EventGraphBase, EventGraphNode, EventGraphNodeAND, EventGraphNodeNotice, EventGraphNodeRender, EventHandlerCalPointerDown, EventHandlerCalPointerMove, EventHandlerCapture, EventHandlerCmdEnd, EventHandlerConfirm, EventHandlerDisableSelect, EventHandlerGenVector3, EventHandlerGeneratePri, EventHandlerGrid, EventHandlerHelpLine, EventHandlerInitCapture, EventHandlerNumberInput, EventHandlerRemoveHelpLine, EventHandlerStart, EventHandlerStringInput, NeedInputEnum, PythaEventName, UpdateType } from "pytha2";
import { EventHandlerGenGridNumberAndMark } from "../event-handler/EHGenGridNumberAndMark";


/**
 * 生成轴号与标注
 */
export class EventGraphGenGridNumberAndMark extends EventGraphBase {

    /**
     * gengridnumber指令 用于注册事件图
     */
    static cmd = 'GENGRIDNUMBER';

    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node3 = new EventGraphNode(this, EventHandlerInitCapture);
        const node4 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node5 = new EventGraphNode(this, EventHandlerCapture);
        const node7 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node8 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node9 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node11 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                type: NeedInputEnum.ACTIVE,
                description: "指定第一个点",
                option: 'F',
                inputTypes: [PythaEventName.POINTER_DOWN]
            }]
        });
        const node12 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                type: NeedInputEnum.ACTIVE,
                description: "指定第二个点",
                option: 'S',
                inputTypes: [PythaEventName.POINTER_DOWN]
            }]
        });
        const node13 = new EventGraphNode(this, EHChangeCrossCursor);
        const node15 = new EventGraphNode(this, EventHandlerHelpLine);
        const node16 = new EventGraphNode(this, EventHandlerGenVector3);
        const node17 = new EventGraphNodeAND(this, null);
        const node18 = new EventGraphNode(this, EventHandlerGenGridNumberAndMark);
        const node19 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                type: NeedInputEnum.ACTIVE,
                description: "指定与第一条轴的角度<0>",
                option: 'A',
                inputTypes: [PythaEventName.NUMBER]
            }]
        });
        const node20 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node21 = new EventGraphNode(this, EventHandlerGrid);
        const node22 = new EventGraphNode(this, EventHandlerNumberInput);
        const node23 = new EventGraphNode(this, EventHandlerRemoveHelpLine);
        const node24 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                {
                    type: NeedInputEnum.ACTIVE,
                    description: "指定起始轴号<1/A>",
                    option: 'N',
                    inputTypes: [PythaEventName.STRING]
                }
            ]
        });
        const node25 = new EventGraphNode(this, EventHandlerStringInput);
        const node26 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node27 = new EventGraphNode(this, EventHandlerConfirm);
        const node28 = new EventGraphNode(this, EventHandlerConfirm);

        this.addEdge(node1, node13);
        this.addEdge(node13, node2);
        this.addEdge(node2, node3);
        this.addEdge(node3, node4);
        this.addEdge(node4, node5);
        this.addEdge(node5, node17);
        this.addEdge(node1, node11);
        this.addEdge(node11, node8);
        this.addEdge(node8, node17);
        this.addEdge(node8, node12);
        this.addEdge(node12, node9);
        this.addEdge(node9, node16);
        this.addEdge(node21, node20);
        this.addEdge(node20, node7);
        this.addEdge(node19, node22);
        this.addEdge(node16, node23);
        this.addEdge(node23, node19);
        this.addEdge(node17, node15);
        this.addEdge(node24, node25);
        this.addEdge(node22, node24);
        this.addEdge(node25, node18);
        this.addEdge(node18, node26);
        this.addEdge(node26, node21);
        this.addEdge(node19, node27);
        this.addEdge(node27, node24);
        this.addEdge(node27, node22, EDGE_TYPE.STOP);
        this.addEdge(node22, node27, EDGE_TYPE.STOP);
        this.addEdge(node24, node28);
        this.addEdge(node28, node18);
        this.addEdge(node25, node28, EDGE_TYPE.STOP);
        this.addEdge(node28, node25, EDGE_TYPE.STOP);

        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;

        // https://event.graph.tncet.com/graphs/128
    }
}